/* Seguimiento de pedido (snippets/aa-tracker.liquid). Consulta POST /track del worker de Andix y dibuja estado,
   etapas, envíos y un mapa de Google Maps (embed sin clave) del destino. Con solo el número el worker no entrega
   productos (sí la comuna, decisión de Elías 02/11); con la clave de los correos (?clave=) o el correo/teléfono de la compra entrega todo. */
(() => {
  const root = document.querySelector('[data-aa-trk]');
  if (!root) return;
  const form = root.querySelector('[data-aa-trk-form]');
  const btn = root.querySelector('[data-aa-trk-btn]');
  const msg = root.querySelector('[data-aa-trk-msg]');
  const out = document.querySelector('[data-aa-trk-out]');
  if (!out) return;
  const endpoint = root.dataset.endpoint;

  const SVG = (d) => `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${d}</svg>`;
  const ICON = {
    ok: SVG('<circle cx="12" cy="12" r="9"/><path d="m8 12 3 3 5-6"/>'),
    box: SVG('<path d="M21 16V8l-9-5-9 5v8l9 5 9-5z"/><path d="M3.3 7.6 12 12.5l8.7-4.9M12 22v-9.5"/>'),
    truck: SVG('<rect x="1" y="4" width="14" height="12" rx="1.5"/><path d="M15 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2.2"/><circle cx="18.5" cy="18.5" r="2.2"/>'),
    route: SVG('<circle cx="6" cy="19" r="2"/><circle cx="18" cy="5" r="2"/><path d="M8 19h7.5a3.5 3.5 0 0 0 0-7h-7a3.5 3.5 0 0 1 0-7H16"/>'),
    home: SVG('<path d="M3 11 12 4l9 7"/><path d="M5 10v10h14V10"/><path d="m9 15 2 2 4-4"/>'),
    pin: SVG('<path d="M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/>'),
    lock: SVG('<rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>'),
    out: SVG('<path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5"/>'),
  };
  const STAGES = [
    ['Confirmado', ICON.ok], ['Preparación', ICON.box], ['Despachado', ICON.truck], ['En reparto', ICON.route], ['Entregado', ICON.home],
  ];
  const HEADLINE = [
    'Recibimos tu pedido', 'Estamos preparando tu pedido', 'Tu pedido va en camino', 'Tu pedido sale hoy a reparto', 'Tu pedido fue entregado',
  ];
  const EVENT = {
    LABEL_PRINTED: 'Etiqueta de envío creada', LABEL_PURCHASED: 'Etiqueta de envío creada', CONFIRMED: 'Envío confirmado',
    CARRIER_PICKED_UP: 'Retirado por el courier', PICKED_UP: 'Retirado', IN_TRANSIT: 'En tránsito', READY_FOR_PICKUP: 'Listo para retiro',
    OUT_FOR_DELIVERY: 'En reparto', ATTEMPTED_DELIVERY: 'Intento de entrega', DELAYED: 'Envío retrasado', DELIVERED: 'Entregado',
    FAILURE: 'Problema con la entrega',
  };
  const ERRORS = {
    not_found: 'No encontramos ese pedido. Revisa el número (por ejemplo, AX-1001003) tal como aparece en tu correo de compra.',
    not_found_contact: 'Ese correo o teléfono no coincide con el de la compra. Usa el mismo que ingresaste al pagar.',
    rate: 'Hiciste varias consultas seguidas. Espera un minuto y vuelve a intentarlo.',
    bad_request: 'Escribe tu número de pedido, por ejemplo AX-1001003.',
  };
  const FALLBACK = 'No pudimos revisar tu pedido en este momento. Inténtalo en unos minutos o escríbenos desde el formulario de contacto.';

  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const tz = { timeZone: 'America/Santiago' };
  const date = (iso) => (iso ? new Date(iso).toLocaleDateString('es-CL', { ...tz, day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/-/g, '/') : '');
  const dateTime = (iso) => (iso ? `${date(iso)} · ${new Date(iso).toLocaleTimeString('es-CL', { ...tz, hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })}` : '');

  let last = { order: '', key: '' };

  function showMsg(text) {
    msg.textContent = text || '';
    msg.hidden = !text;
  }

  function pill(o) {
    if (o.state === 'cancelled') return ['Anulado', 'is-off'];
    if (o.state === 'pending_payment') return ['Esperando pago', 'is-wait'];
    if (o.state === 'no_shipping') return ['Confirmado', 'is-ok'];
    if (o.state === 'partial') return ['Despacho parcial', 'is-go'];
    return [STAGES[o.stage][0], o.stage === 4 ? 'is-ok' : 'is-go'];
  }

  function headline(o) {
    if (o.state === 'cancelled') return ['Este pedido fue anulado', o.refunded ? 'El reembolso ya fue procesado.' : 'Si tienes dudas, escríbenos con tu número de pedido.'];
    if (o.state === 'pending_payment') return ['Esperando tu pago', 'Apenas se acredite, empezamos a preparar tu pedido.'];
    if (o.state === 'no_shipping') return ['Pedido confirmado', 'Este pedido no requiere despacho.'];
    if (o.state === 'partial') return ['Tu pedido viaja en partes', 'Va en más de un paquete. Abajo ves el seguimiento de cada uno.'];
    const s = o.shipments.find((x) => x.estimatedAt && !x.deliveredAt);
    const d = o.shipments.find((x) => x.deliveredAt);
    const sub = o.stage === 4 && d ? `Entregado el ${date(d.deliveredAt)}.`
      : s ? `Llegada estimada: ${date(s.estimatedAt)}.`
      : o.stage < 2 ? 'Te avisaremos por correo apenas salga a despacho.' : '';
    return [HEADLINE[o.stage], sub];
  }

  function steps(o) {
    if (o.state === 'cancelled' || o.state === 'no_shipping') return '';
    const current = o.state === 'pending_payment' ? -1 : o.stage;
    const pct = current <= 0 ? 0 : (current / (STAGES.length - 1)) * 100;
    return `<div class="aa-trk__track" style="--aa-trk-pct:${pct}"><ol class="aa-trk__steps" role="list">${STAGES.map(([label, icon], i) => {
      const cls = i < current || (i === current && i === 4) ? 'is-done' : i === current ? 'is-now' : '';
      const sr = cls === 'is-done' ? ' (listo)' : cls === 'is-now' ? ' (etapa actual)' : '';
      return `<li class="aa-trk__step ${cls}"${cls === 'is-now' ? ' aria-current="step"' : ''}><span class="aa-trk__dot">${icon}</span><span class="aa-trk__step-label">${label}<span class="aa-trk__sr">${sr}</span></span></li>`;
    }).join('')}</ol></div>`;
  }

  function shipment(s, i, total) {
    const events = s.events.length
      ? `<ol class="aa-trk__events" role="list">${s.events.map((e) => `<li><strong>${esc(EVENT[e.status] || e.message || 'Actualización')}</strong><span>${esc(dateTime(e.at))}${e.place ? ` · ${esc(e.place)}` : ''}</span></li>`).join('')}</ol>`
      : '';
    const items = total > 1 && s.items.length ? `<p class="aa-trk__ship-items">${s.items.map((it) => `${esc(it.title)} x${it.qty}`).join(' · ')}</p>` : '';
    const number = s.number
      ? `<div class="aa-trk__num"><span>N.º de seguimiento</span><code>${esc(s.number)}</code><button type="button" class="aa-trk__copy" data-copy="${esc(s.number)}">Copiar</button></div>`
      : '<p class="aa-trk__muted">El número de seguimiento aparecerá aquí apenas el courier lo entregue.</p>';
    const link = s.url
      ? `<a class="aa-btn aa-btn--outline aa-trk__link" href="${esc(s.url)}" target="_blank" rel="noopener noreferrer">Seguir en ${esc(s.company || 'el sitio del courier')}${ICON.out}</a>`
      : '';
    return `<div class="aa-trk__ship">
      <p class="aa-trk__ship-title">${total > 1 ? `Paquete ${i + 1} · ` : ''}${esc(EVENT[s.status] || STAGES[s.stage][0])}</p>
      <dl class="aa-trk__facts">
        ${s.company ? `<div><dt>Courier</dt><dd>${esc(s.company)}</dd></div>` : ''}
        ${s.shippedAt ? `<div><dt>Despachado</dt><dd>${esc(date(s.shippedAt))}</dd></div>` : ''}
        ${s.deliveredAt ? `<div><dt>Entregado</dt><dd>${esc(date(s.deliveredAt))}</dd></div>` : s.estimatedAt ? `<div><dt>Llegada estimada</dt><dd>${esc(date(s.estimatedAt))}</dd></div>` : ''}
      </dl>
      ${items}${number}${link}${events}
    </div>`;
  }

  // Mapa propio de Chile (assets/aa-chile.svg + aa-chile-XX.svg con las comunas de cada región; sin terceros).
  // Con comuna reconocida (o.point = [x, y, código]): acercamiento a la comuna con un pin. Si la comuna no se
  // reconoce: la región con sus comunas, la ruta desde Santiago y el camión según la etapa. Nunca la dirección exacta.
  const ORIGIN = [439, 1645]; // Santiago (lon -70,65, lat -33,45) en las coordenadas del SVG
  const SVGNS = 'http://www.w3.org/2000/svg';
  const cache = {};
  let maps = {};
  try { maps = JSON.parse(root.dataset.maps || '{}'); } catch {}
  const loadSvg = (url) => (cache[url] ||= fetch(url).then((r) => (r.ok ? r.text() : Promise.reject())).then((t) => {
    const d = new DOMParser().parseFromString(t, 'image/svg+xml').documentElement;
    return d && d.nodeName === 'svg' ? d : null;
  }).catch(() => { delete cache[url]; return null; }));

  function map(o) {
    if (!o.regionCode || o.state === 'cancelled' || o.state === 'no_shipping') return '';
    const place = [o.city, o.region].filter(Boolean).join(', ');
    return `<figure class="aa-trk__map">
      <figcaption class="aa-trk__map-head">${ICON.pin}<span><small>Destino</small><strong>${esc(place)}</strong></span></figcaption>
      <div class="aa-trk__map-frame" data-aa-trk-map role="img" aria-label="Mapa de Chile con el destino del pedido: ${esc(place)}"></div>
      <p class="aa-trk__map-legend">${o.point ? `<span class="is-to">Comuna de destino: ${esc(o.city)}</span>` : `<span class="is-from">Despacho desde Santiago</span><span class="is-to">${esc(o.region)}</span>`}</p>
    </figure>`;
  }

  function el(tag, attrs) {
    const n = document.createElementNS(SVGNS, tag);
    for (const k in attrs) n.setAttribute(k, attrs[k]);
    return n;
  }

  async function drawMap(o) {
    const frame = out.querySelector('[data-aa-trk-map]');
    if (!frame) return;
    const fail = () => { const f = frame.closest('.aa-trk__map'); if (f) f.hidden = true; };
    const [src, com] = await Promise.all([loadSvg(root.dataset.map), maps[o.regionCode] ? loadSvg(maps[o.regionCode]) : null]);
    if (!src || !frame.isConnected) return fail();

    const svg = el('svg', { class: 'aa-trk__chile', preserveAspectRatio: 'xMidYMid meet', 'aria-hidden': 'true', focusable: 'false' });
    const land = el('g', { class: 'aa-trk__land' });
    [...src.querySelectorAll('path')].forEach((p) => {
      const n = el('path', { d: p.getAttribute('d'), 'vector-effect': 'non-scaling-stroke' });
      if (p.id === o.regionCode) n.setAttribute('class', 'is-dest');
      land.append(n);
    });
    svg.append(land);
    const comunas = el('g', { class: 'aa-trk__comunas' });
    const code = o.point && o.point[2] ? `c${o.point[2]}` : '';
    if (com) {
      [...com.querySelectorAll('path')].forEach((p) => {
        const n = el('path', { d: p.getAttribute('d'), 'vector-effect': 'non-scaling-stroke' });
        if (p.id === code) n.setAttribute('class', 'is-dest');
        comunas.append(n);
      });
    }
    svg.append(comunas);
    if (com) frame.closest('.aa-trk__map').classList.add('has-com');
    if (!code) comunas.classList.add('is-region');
    frame.replaceChildren(svg);
    const region = land.querySelector('.is-dest');
    if (!region) return fail();
    const comuna = code ? comunas.querySelector('.is-dest') : null;
    if (comuna) comunas.append(comuna); // encima de las vecinas

    // Encuadre: la comuna (con sus vecinas) o la región + Santiago, con la proporción del recuadro
    const rb = (comuna || region).getBBox();
    let x0; let y0; let x1; let y1;
    if (comuna) {
      const side = Math.max(rb.width, rb.height, 4);
      x0 = rb.x - side * 1.1; y0 = rb.y - side * 1.1; x1 = rb.x + rb.width + side * 1.1; y1 = rb.y + rb.height + side * 1.1;
    } else {
      x0 = Math.min(rb.x, ORIGIN[0]); y0 = Math.min(rb.y, ORIGIN[1]);
      x1 = Math.max(rb.x + rb.width, ORIGIN[0]); y1 = Math.max(rb.y + rb.height, ORIGIN[1]);
      const pad = Math.max(x1 - x0, y1 - y0) * 0.16 + 12;
      x0 -= pad; y0 -= pad; x1 += pad; y1 += pad;
    }
    const ratio = frame.clientWidth / Math.max(1, frame.clientHeight) || 4 / 3;
    let w = x1 - x0; let h = y1 - y0;
    if (w / h < ratio) { const nw = h * ratio; x0 -= (nw - w) / 2; w = nw; } else { const nh = w / ratio; y0 -= (nh - h) / 2; h = nh; }
    svg.setAttribute('viewBox', `${x0} ${y0} ${w} ${h}`);
    const u = w / Math.max(1, frame.clientWidth); // unidades por píxel
    const dot = (x, y, r, cls) => svg.append(el('circle', { cx: x, cy: y, r: r * u, class: cls }));

    if (comuna) {
      // Pin en el centro de la comuna
      const [px, py] = [o.point[0], o.point[1]];
      dot(px, py, 16, 'aa-trk__halo');
      const pin = el('g', { class: 'aa-trk__pin', transform: `translate(${px} ${py}) scale(${u})` });
      pin.append(el('path', { d: 'M0 0C-5-7-11-12-11-19a11 11 0 0 1 22 0C11-12 5-7 0 0z' }));
      pin.append(el('circle', { cy: -19, r: 4.2 }));
      svg.append(pin);
    } else {
      // Ruta curva hacia el mar, de Santiago al centro de la región, y el camión según la etapa
      const to = [rb.x + rb.width / 2, rb.y + rb.height / 2];
      const [ax, ay] = ORIGIN; const [bx, by] = to;
      const len = Math.hypot(bx - ax, by - ay);
      const d = `M${ax} ${ay}Q${(ax + bx) / 2 - len * 0.32 - 8 * u} ${(ay + by) / 2} ${bx} ${by}`;
      svg.append(el('path', { d, class: 'aa-trk__route-bg', 'vector-effect': 'non-scaling-stroke' }));
      const route = el('path', { d, class: 'aa-trk__route', 'vector-effect': 'non-scaling-stroke' });
      svg.append(route);
      dot(ax, ay, 5, 'aa-trk__from');
      dot(bx, by, 14, 'aa-trk__halo');
      dot(bx, by, 6, 'aa-trk__to');
      const t = o.state === 'pending_payment' ? 0 : [0, 0, 0.5, 0.86, 1][o.stage] ?? 0;
      const pt = route.getPointAtLength(route.getTotalLength() * t);
      const truck = el('g', { class: o.stage === 4 ? 'aa-trk__truck is-done' : 'aa-trk__truck', transform: `translate(${pt.x} ${pt.y}) scale(${u})` });
      truck.append(el('circle', { r: 15 }));
      const icon = el('g', { transform: 'translate(-9 -9) scale(.75)' });
      icon.innerHTML = o.stage === 4
        ? '<path d="m6 12 4 4 8-8"/>'
        : '<rect x="1" y="4" width="14" height="12" rx="1.5"/><path d="M15 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2.2"/><circle cx="18.5" cy="18.5" r="2.2"/>';
      truck.append(icon);
      svg.append(truck);
    }

    // Chile completo en miniatura, con el recuadro de la vista
    const mini = el('svg', { class: 'aa-trk__mini', viewBox: src.getAttribute('viewBox'), 'aria-hidden': 'true', focusable: 'false' });
    [...land.children].forEach((p) => mini.append(p.cloneNode()));
    const [mx, my, mw, mh] = src.getAttribute('viewBox').split(' ').map(Number);
    const bx0 = Math.max(x0, mx); const by0 = Math.max(y0, my);
    const bx1 = Math.min(x0 + w, mx + mw); const by1 = Math.min(y0 + h, my + mh);
    const minBox = 30; // el recuadro de una comuna sería invisible: mínimo visible
    const cxm = (bx0 + bx1) / 2; const cym = (by0 + by1) / 2;
    const bw = Math.max(minBox, bx1 - bx0); const bh = Math.max(minBox, by1 - by0);
    mini.append(el('rect', { x: cxm - bw / 2, y: cym - bh / 2, width: bw, height: bh, class: 'aa-trk__mini-box', 'vector-effect': 'non-scaling-stroke' }));
    frame.append(mini);
  }

  function recipient(r) {
    if (!r) return '';
    const row = (label, value) => (value ? `<div><dt>${label}</dt><dd>${esc(value)}</dd></div>` : '');
    return `<div class="aa-trk__box"><p class="aa-trk__box-title">${ICON.pin}Datos de entrega</p>
      <dl class="aa-trk__who">${row('Recibe', r.name)}${row('Dirección', r.street)}${row('Comuna', r.place)}${row('Teléfono', r.phone)}</dl>
      <p class="aa-trk__muted aa-trk__who-note">${ICON.lock}<span>Por seguridad ocultamos parte de tus datos. Si algo no está bien, <a href="/pages/contact?motivo=problema">escríbenos</a>.</span></p></div>`;
  }

  function items(o) {
    if (o.full) {
      return recipient(o.recipient) + (o.items.length ? `<div class="aa-trk__box"><p class="aa-trk__box-title">Tu compra</p><ul class="aa-trk__items" role="list">${o.items.map((it) => `<li>
        ${it.image ? `<img src="${esc(it.image)}" alt="${esc(it.alt)}" width="56" height="56" loading="lazy" decoding="async">` : '<span class="aa-trk__noimg" aria-hidden="true"></span>'}
        <span><strong>${esc(it.title)}</strong>${it.variant ? `<small>${esc(it.variant)}</small>` : ''}</span><span class="aa-trk__qty">x${it.qty}</span></li>`).join('')}</ul></div>` : '');
    }
    return `<form class="aa-trk__box aa-trk__more" data-aa-trk-more novalidate>
      <p class="aa-trk__box-title">${ICON.lock}Ver productos y datos de entrega</p>
      <p class="aa-trk__muted">Por tu privacidad, con solo el número mostramos el estado y la comuna de destino. Para ver los productos y los datos de entrega, escribe el correo o teléfono de la compra (o entra desde el botón de tu correo).</p>
      <label class="aa-trk__sr" for="aa-trk-contact">Correo o teléfono de la compra</label>
      <div class="aa-trk__more-row">
        <input id="aa-trk-contact" name="contacto" type="text" inputmode="email" autocomplete="email" spellcheck="false" maxlength="120" placeholder="tu@correo.cl o +56 9…">
        <button type="submit" class="aa-btn aa-btn--outline">Ver detalle</button>
      </div>
      <p class="aa-trk__msg" role="alert" data-aa-trk-more-msg hidden></p>
    </form>`;
  }

  function render(o) {
    const [label, tone] = pill(o);
    const [title, sub] = headline(o);
    const ships = o.shipments.length
      ? o.shipments.map((s, i) => shipment(s, i, o.shipments.length)).join('')
      : o.state === 'active' ? '<p class="aa-trk__muted aa-trk__ship">Cuando despachemos tu pedido verás aquí el courier y el número de seguimiento.</p>' : '';
    out.innerHTML = `
      <div class="aa-trk__sum">
        <div><p class="aa-trk__order">Pedido ${esc(o.name)}</p><p class="aa-trk__muted">Realizado el ${esc(date(o.date))}</p></div>
        <span class="aa-trk__pill ${tone}">${esc(label)}</span>
      </div>
      <div class="aa-trk__status">
        <p class="aa-trk__headline">${esc(title)}</p>
        ${sub ? `<p class="aa-trk__sub">${esc(sub)}</p>` : ''}
      </div>
      ${steps(o)}
      <div class="aa-trk__grid">
        <div class="aa-trk__main">${ships}${items(o)}</div>
        ${map(o)}
      </div>
      <p class="aa-trk__help">¿Algo no cuadra? <a href="/pages/contact?motivo=problema&amp;pedido=${encodeURIComponent(o.name)}">Escríbenos</a> con tu número de pedido.</p>`;
    out.hidden = false;
    drawMap(o);
    out.focus({ preventScroll: true });
    const top = out.getBoundingClientRect().top;
    if (top < 0 || top > window.innerHeight * 0.7) {
      const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      out.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
    }
  }

  async function lookup(order, { key = '', contact = '', moreMsg = null } = {}) {
    showMsg('');
    if (!order.trim()) return showMsg(ERRORS.bad_request);
    btn.disabled = true;
    root.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ order: order.trim(), key, contact: contact.trim() }),
      });
      const data = await res.json().catch(() => ({}));
      if (data.ok && data.order) {
        last = { order: order.trim(), key };
        render(data.order);
      } else if (moreMsg) {
        moreMsg.textContent = data.error === 'not_found' ? ERRORS.not_found_contact : ERRORS[data.error] || FALLBACK;
        moreMsg.hidden = false;
      } else { out.hidden = true; showMsg(ERRORS[data.error] || FALLBACK); }
    } catch {
      if (moreMsg) { moreMsg.textContent = FALLBACK; moreMsg.hidden = false; } else { out.hidden = true; showMsg(FALLBACK); }
    } finally {
      btn.disabled = false;
      root.removeAttribute('aria-busy');
    }
  }

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const order = form.pedido.value;
    lookup(order, { key: order.trim() === last.order ? last.key : '' });
  });

  out.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-aa-trk-more]');
    if (!f) return;
    e.preventDefault();
    const m = f.querySelector('[data-aa-trk-more-msg]');
    m.hidden = true;
    if (!f.contacto.value.trim()) { m.textContent = 'Escribe el correo o teléfono que usaste al comprar.'; m.hidden = false; return; }
    lookup(last.order || form.pedido.value, { contact: f.contacto.value, moreMsg: m });
  });

  out.addEventListener('click', (e) => {
    const b = e.target.closest('[data-copy]');
    if (!b || !navigator.clipboard) return;
    navigator.clipboard.writeText(b.dataset.copy).then(() => {
      b.textContent = 'Copiado';
      setTimeout(() => { b.textContent = 'Copiar'; }, 2000);
    }, () => {});
  });

  // Links from the emails: ?pedido=AX-1001005&clave=<token>. The number alone is enough to search.
  const q = new URLSearchParams(location.search);
  const pre = (q.get('pedido') || q.get('order') || '').slice(0, 20);
  const preKey = (q.get('clave') || '').replace(/[^A-Za-z0-9]/g, '').slice(0, 64);
  const preContact = (q.get('contacto') || q.get('email') || '').slice(0, 120);
  if (pre) {
    form.pedido.value = pre;
    lookup(pre, { key: preKey, contact: preContact });
    // Keep the key out of the address bar (and out of screenshots or shared links)
    if (preKey || preContact) history.replaceState(null, '', `${location.pathname}?pedido=${encodeURIComponent(pre)}${location.hash}`);
  }
})();
